import dayjs, { Dayjs } from "dayjs"
import advancedFormat from "dayjs/plugin/advancedFormat"
import customParseFormat from "dayjs/plugin/customParseFormat"
import timezone from "dayjs/plugin/timezone"
import utc from "dayjs/plugin/utc"

dayjs.extend(advancedFormat)
dayjs.extend(customParseFormat)
dayjs.extend(utc)
dayjs.extend(timezone)

export const DateFormats = {
  default: "DD/MM/YYYY",
  shortYear: "DD/MM/YY",
  dashed: "DD-MM-YYYY",
  long: "D MMM YYYY",
  ordinal: "Do MMMM YYYY",
  ordinalMonthShort: "Do MMM YYYY",
  api: "YYYY-MM-DD",
  dayLongMonthShort: "Do MMM YYYY",
  dayOnly: "D",
  dayMonthShort: "D MMM",
  dayMonthFull: "D MMMM",
  dayMonthFullYear: "D MMMM YYYY",
  weekdayDayMonthFullYear: "dddd D MMMM YYYY",
  dayMonthNamedShortWithYear: "ddd D MMM YYYY",
  weekDayMonthDayLong: "ddd Do MMM",
  dayLongMonthShortNoYear: "ddd Do MMM",
  monthYear: "MMMM YYYY",
  dateTime: "DD MMM YYYY, HH:mm",
  ordinalDay: "Do",
} as const

export const formatDate = (
  date: Dayjs | string,
  format: keyof typeof DateFormats = "default",
  inputFormat?: keyof typeof DateFormats,
): string => {
  const input = inputFormat ? DateFormats[inputFormat] : undefined
  return dayjs(date, input).format(DateFormats[format])
}

export const parseApiDate = (value: unknown): Dayjs | undefined => {
  if (typeof value !== "string") return undefined
  const parsed = dayjs(value, DateFormats.api, true)
  return parsed.isValid() ? parsed : undefined
}

export const formatOrdinalDay = (day: number): string =>
  dayjs().date(day).format(DateFormats.ordinalDay)

export const toUKTime = (date: string | Dayjs) =>
  dayjs(date).tz("Europe/London")

export const today = () => dayjs().tz("Europe/London")

export const isSameYear = (a: Dayjs | string, b: Dayjs | string): boolean =>
  dayjs(a).isSame(dayjs(b), "year")

export const isSameMonth = (a: Dayjs | string, b: Dayjs | string): boolean =>
  dayjs(a).isSame(dayjs(b), "month")

export const addWeekdays = (date: Dayjs, days: number): Dayjs => {
  let d = date
  while (days > 0) {
    d = d.add(1, "day")
    if (d.day() !== 0 && d.day() !== 6) days--
  }
  return d
}
